// extracted by mini-css-extract-plugin
export default {"miniPaintingItemContainer":"miniPaintingView_miniPaintingItemContainer__Sgo29","subtitleContainer":"miniPaintingView_subtitleContainer__x-KNC"};